import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

export const notificationRuleEditSchema = z.object({
  id: z
    .string()
    .nullish()
    .superRefine(
      fieldConfig({
        inputProps: {
          disabled: true,
        },
      }),
    ),
  verdict: z.string().min(1),
  value: z.string().min(1),
  explanation: z
    .string()
    .min(1)
    .superRefine(
      fieldConfig({
        fieldType: "textarea",
      }),
    ),
  enabled: z.boolean().default(true),
});

export type NotificationRuleEditFormType = z.infer<typeof notificationRuleEditSchema>;

// The create screen enters the verdict ONCE and adds several (value, explanation)
// pairs at once; on submit each pair POSTs its own flat row (one row per
// (verdict, value) — the orchestrator's data model). `enabled` applies to every
// row created in the submit.
export const notificationRuleValueSchema = z.object({
  value: z.string().min(1, "Value is required"),
  explanation: z.string().min(1, "Explanation is required"),
});

export const notificationRulesCreateSchema = z.object({
  verdict: z.string().min(1, "Verdict is required"),
  enabled: z.boolean().default(true),
  values: z.array(notificationRuleValueSchema).min(1),
});

export type NotificationRuleValueType = z.infer<typeof notificationRuleValueSchema>;
export type NotificationRulesCreateFormType = z.infer<
  typeof notificationRulesCreateSchema
>;
